import { queryOptions } from "@tanstack/react-query";

import { getCoachAccount } from "~/lib/functions/coach-account";

export function coachAccountQueryOptions(userId: string | undefined) {
  return queryOptions({
    queryKey: ["coach-account", userId],
    queryFn: () => getCoachAccount(),
    // Billing state moves out of band (a Stripe webhook, a trial ending), so
    // this has to revalidate on its own rather than sit on a long cache. It is
    // read on every /my-coaching navigation, so a zero stale time would add a
    // round-trip to each one — half a minute is short next to any billing
    // change a coach triggers themselves, and those paths re-sync anyway.
    staleTime: 30 * 1000,
    enabled: !!userId,
  });
}
